import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'

Vue.use(VueRouter)

function lazyLoad (view) {
  return () => import(`@/views/${view}.vue`)
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/calculator',
    name: 'calculator',
    component: lazyLoad('Calculator')
  },
  {
    path: '/savings',
    name: 'savings',
    component: lazyLoad('Savings')
  },
  {
    path: '/cookie-policy',
    name: 'cookie-policy',
    component: lazyLoad('CookiePolicies/CookiePolicyEN')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router